export default "__VITE_ASSET__w0JB_Hve__"